export default [
  '$uibModalInstance',
  'onApprove',
  'dealRentService',
  'analyticsService',
  'config',
  function (
    $uibModalInstance,
    onApprove,
    dealRentService,
    analyticsService,
    config,
  ) {
  this.title = 'Безопасная аренда со Сдай/Сними от Циан';

  const homeownerSubscriptionPaymentEnabled = config.get(
    'homeownerSubscriptionPayment.enabled',
  );
  this.paymentText = homeownerSubscriptionPaymentEnabled
    ? '1 990 ₽ в месяц, ничего не спишем, пока не заключён договор. Никакой комиссии с арендаторов.'
    : 'Сможете пользоваться сервисом бесплатно, а комиссия арендатора всего 15% и подписка 990 ₽ в месяц';

  this.images = {
    rocket: require('./assets/rocket.png'),
    detective: require('./assets/detective.png'),
    heart: require('./assets/heart.png'),
    home: require('./assets/home.png'),
    card: require('./assets/card.png'),
  };

  this.onApprove = () => {
    $uibModalInstance.closed.then(() => {
      analyticsService.trackDealRentTrapInFpToConfirmClick();
      dealRentService.openTrapInFpConfirmPopup(onApprove);
    });
    $uibModalInstance.dismiss();
  };
}];
